import React, { useState } from 'react';
import { Textarea, Frame, SageClassnames } from '@kajabi/sage-react';
import { useFormikContext } from 'formik';
import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';
import { useUiResourceContext, useConfigContext } from 'common/components/CopyMagic/contexts';
import { PLACEHOLDER_TEXT } from 'common/components/CopyMagic/constants';

type Props = {
  labelText: string;
};

const PromptForm = ({ labelText }: Props) => {
  const { touched, errors, handleBlur, handleChange, values } =
    useFormikContext<PromptFormValuesType>();
  const { productEvents } = useConfigContext();
  const productArea = productEvents?.payload?.['Product Area']?.toString() ?? 'Default';
  const placeholderText = PLACEHOLDER_TEXT[productArea] || PLACEHOLDER_TEXT.Default;
  const { loading } = useUiResourceContext();
  const trackInputFieldClicked = useGeneratorTrackingCallback('useTrackInputFieldClicked');
  const [inputClickedEventTracked, setInputClickedEventTracked] = useState(false);

  const handleClick = () => {
    if (inputClickedEventTracked === false) {
      trackInputFieldClicked();
      setInputClickedEventTracked(true);
    }
  };

  return (
    <Frame
      border={Frame.BORDERS.NONE}
      gap={Frame.GAPS.NONE}
      width={Frame.WIDTHS.FILL}
      align={Frame.ALIGNMENTS.CENTER_SPREAD}
      className={SageClassnames.SPACERS.XS_BOTTOM}
    >
      <div>
        <Textarea
          id="topic"
          label={labelText}
          placeholder={placeholderText}
          data-testid="topic"
          disabled={loading}
          value={values.topic}
          onClick={handleClick}
          onChange={handleChange}
          onBlur={handleBlur}
          hasError={touched.topic && !!errors.topic}
          message={touched.topic && errors.topic}
        />
      </div>
    </Frame>
  );
};

export default PromptForm;
